import { MutationHookOptions, useMutation } from '@apollo/client';
import gql from 'graphql-tag';

const UPSERT_STREAK_HISTORY_MUTATION = gql`
  mutation upsertStreakHistoryEntry($userId: String!, $data: StreakHistoryInput!) {
    upsertStreakHistoryEntry(userId: $userId, data: $data) {
      _id
      userId
      currentStreak
      longestStreak
      lastUpdatedAt
      history {
        streakCount
        earnedAt
        seen
      }
    }
  }
`;

export interface UpsertStreakHistoryMutationType {
  upsertStreakHistoryEntry: {
    _id: string;
    userId: string;
    currentStreak: number;
    longestStreak: number;
    lastUpdatedAt?: string;
    history: {
      streakCount: number;
      earnedAt: string;
      seen?: boolean;
    }[];
  };
}

export interface UpsertStreakHistoryMutationVariables {
  userId: string;
  data: {
    streakCount: number;
    earnedAt: string;
    seen?: boolean;
  };
}

export function useUpsertStreakHistoryMutation(
  options?: MutationHookOptions<
    UpsertStreakHistoryMutationType,
    UpsertStreakHistoryMutationVariables
  >,
) {
  return useMutation<UpsertStreakHistoryMutationType, UpsertStreakHistoryMutationVariables>(
    UPSERT_STREAK_HISTORY_MUTATION,
    options,
  );
}
